import React, { useState } from 'react'

import './Navbar.scss';
// import { images } from '../../constants';
import { HiMenuAlt4, HiX} from 'react-icons/hi';
import { motion } from 'framer-motion';
import { BsTwitter, BsInstagram, BsYoutube, BsLinkedin } from 'react-icons/bs';
import { FaFacebookF } from 'react-icons/fa';

const Navbar = () => {
  const [toggle, setToggle] = useState(false)
  return (
    <nav className="app__navbar">
      <div className="app__navbar-logo">
        {/* <img src={images.logo} alt="logo" /> */}
        <div className="app__title">
              <font face="Lucida_Handwriting">
                <span className="name-style">R</span>
                <span>ajeesh </span>
                <span className="name-style">U</span>
                <span>pendran</span>
              </font>
          </div>

      </div>
      <ul className="app__navbar-links">
        {[ 'home', 'about', 'skills', 'contact'].map((item) => (
          <li className="app__flex p-text" key={`link-${item}`}>
            <div />
            <a href={`#${item}`} >{item}</a>
          </li>
        ))}
      </ul>
      <div className="app__navbar-menu">
          <HiMenuAlt4 onClick={() => setToggle(true)} />
          {
            toggle && (
              <motion.div 
              whileInView={{x: [300, 0]}} 
              transition={{duration: 0.85, ease: 'easeOut'}}
              >
                <HiX onClick={() => setToggle(false)} />
                <ul>
                  {[ 'home', 'about', 'skills', 'contact'].map((item) => (
                    <li key={item}>
                      <a href={`#${item}`} onClick={() => setToggle(false)}>{item}</a>
                    </li>
                  ))}
                </ul>
              </motion.div>
            )
          }
      </div>
      <div className="app__social_navbar">
        <div>
          <a href='https://www.youtube.com/rajeeshupendran' target="_blank" rel="noreferrer">
            <BsYoutube />
          </a>
        </div>
        <div>
          <a href='http://www.linkedin.com/in/rajeeshupendran' target='_blank' rel="noreferrer">
            <BsLinkedin />
          </a>
        </div>
        <div>
          <a href='http://twitter.com/rajeeshupendran' target='_blank' rel="noreferrer">
            <BsTwitter />
          </a>
        </div>
        <div>
          <a href='http://www.facebook.com/rajeesh.upendran' target='_blank' rel="noreferrer">
            <FaFacebookF />
          </a>
        </div>
        <div>
          <a href='https://www.instagram.com/rajeeshupendran/' target='_blank' rel="noreferrer">
            <BsInstagram />
          </a>
        </div>
    </div>
    </nav>
  )
}

export default Navbar